module.exports = __webpack_public_path__ + "media/images/tutorial_header_pc3-01-533d81db2894c5d8b9130e8298c21560.png";